import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation,PapiUser } from '@wix/da-papi-types';
import {
  BiData,
  GiveAdoptableGiftConfirmClickBiEvent,
} from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import { friendsStreamId } from '../../../../../../../../redux/users/constants';
import DeviantsListCard from '../../../../../../../../DeviantsList/DeviantsListCard';
import EmptyView from './EmptyView';
import s from './GiftExclusivePopup.scss';

export interface Props {
  onItemClick: (user: PapiUser) => void;
  deviation: PapiDeviation;
  requestClose(): void;
}

const GiftExclusivePopup: React.FC<Props> = ({
  requestClose,
  deviation,
  onItemClick,
}) => {
  const { t } = useTranslation();

  return (
    <DSModal
      isOpen
      showHeaderBorder
      useFixedMobileHeight
      heading={t('popup.giftExclusive.heading')}
      className={s['root']}
      layoutClassName={s['layout-root']}
      contentClassName={s['content-root']}
      onRequestClose={requestClose}
      withScrollableContentWrapper={false}
      hasCloseButton={true}
    >
      <section className={s['content']}>
        <Flex direction="column" fullHeight>
          <div className={s['intro']}>
            {t('popup.giftExclusive.body')}
            <div>
              {t('popup.giftExclusive.body.learnMore', {
                postProcess: ['reactPostprocessor'],
                learnLink: (
                  <PlainButtonOrLink
                    className={s['learn-more-link']}
                    href="https://www.deviantartsupport.com/en/article/how-do-i-give-an-exclusive-to-another-deviant-as-a-gift"
                  >
                    {t('popup.giftExclusive.link.learnMore')}
                  </PlainButtonOrLink>
                ),
              })}
            </div>
          </div>
          <FlexItem grow shrink>
            <DeviantsListCard
              className={s['deviants-list']}
              contentClassName={s['deviants-list-content']}
              deviantsStreamId={friendsStreamId}
              onItemClick={onItemClick}
              emptyView={<EmptyView />}
              itemBiData={BiData<GiveAdoptableGiftConfirmClickBiEvent>({
                evid: 758,
                typeid: deviation.typeId,
                itemid: deviation.deviationId,
                is_seller_gift: 0,
              })}
              itemSuffix={
                <TextButton
                  size="small"
                  variant="main"
                  className={s['gift-button']}
                >
                  <Flex alignItems="center" justifyContent="center" gap={2}>
                    <GiftIcon className={s['gift-icon']} disableDefaultColors />
                    {t('popup.giftExclusive.button.giftExclusive')}
                  </Flex>
                </TextButton>
              }
            />
          </FlexItem>
        </Flex>
      </section>
    </DSModal>
  );
};
GiftExclusivePopup.displayName = 'GiftExclusivePopup';

export default GiftExclusivePopup;
